import {
  ClassToJson,
  ExpandContentHandleClick,
  EcommerceParentObject,
  Item,
  WatchGA4Obj,
  CTAClickHandleClick,
} from 'helpers-ga4';

import {
  CreateCartParentGA4Object,
  CreateCartItemsObject,
} from 'cart-helpers-v2';

const ns_main_product = {
  AccordionItems: `.product__accordion [data-ga4-id='expand_content']`,

  AddToCartButton: `[data-ga4-id='add_to_cart']:not(.petivity-quick-view__add-to-cart):not(.quick-add--button)`,

  QuantityInput: `[data-ga4-quantity-id='add_to_cart']`,

  Reviews: `[data-bv-show="reviews"]`,

  AddCartItem(e) {
    let target = e.target;
    if (!e.target.dataset || e.target.dataset.ga4ItemId === undefined) {
      target = e.target.parentElement;
    }
    CreateCartItemsObject(
      target,
      CreateCartParentGA4Object('add_to_cart', target),
      true,
      e,
      true,
    );
    CTAClickHandleClick(e);
  },

  UpdateQuantityDataAttr(e) {
    const quantity = e.target.value;

    document
      .querySelectorAll(ns_main_product.AddToCartButton)
      .forEach((button) => {
        button.setAttribute('data-ga4-quantity', quantity);
      });
  },

  CreateGA4Object() {
    const convertToNumber = (str) => {
      if (str === undefined || str === null || str === '') return 0;
      return Number(String(str).replace(/\,/g, ''));
    };

    const parentObject = new EcommerceParentObject({
      event: 'view_item',
      value: convertToNumber(MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.value || 0),
      currency: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.currency}`,
    });

    const variants = document.querySelector(
      'variant-radios.variants-color__images',
    );
    let item_variant = MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.name;
    let item_variant_id = MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.variant;
    if (variants) {
      const selectedVariant = variants.querySelector('.selected-color');
      item_variant =
        selectedVariant?.dataset.selectedVariant != 'Default Title'
          ? selectedVariant?.dataset.selectedVariant
          : item_variant;
      item_variant_id =
        selectedVariant?.dataset.selectedVariantId || item_variant_id;
    }

    const itemObject = new Item({
      purchase_type: `NULL`,
      item_name: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.name}`,
      item_id: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.id}`,
      item_brand: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.brand}`,
      item_category: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.category}`,
      item_variant: `${item_variant}`,
      shopify_variant_id: `${item_variant_id}`,
      quantity: '1',
      price: `${MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ.price}`,
    });

    parentObject.event_params.ecommerce.items.push(itemObject);

    // Use window.ExecuteGA4Event to ensure it's available globally
    if (typeof window !== 'undefined' && window.ExecuteGA4Event) {
      window.ExecuteGA4Event(ClassToJson(parentObject));
    } else {
      console.error(
        'ExecuteGA4Event is not available. Make sure global.js is loaded before this module.',
      );
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  // Accordions: GA4 'expand_content' event
  document.querySelectorAll(ns_main_product.AccordionItems).forEach((item) => {
    item.addEventListener('click', ExpandContentHandleClick);
  });

  // Add To Cart Button: GA4 'add_to_cart' event
  // Use event delegation to handle both existing and dynamically added buttons
  document.addEventListener('click', (e) => {
    const addToCartButton = e.target.closest(ns_main_product.AddToCartButton);
    if (addToCartButton) {
      ns_main_product.AddCartItem(e);
    }

    const copyButton = e.target.closest('#copyBtn');
    if (copyButton) {
      const discountText = copyButton.dataset.clipboardText;
      const announcer = copyButton.parentElement.querySelector(
        '[data-copy-announcer]',
      );
      navigator.clipboard.writeText(discountText).then(() => {
        const copiedIcon = copyButton.querySelector('.copied-icon');
        const copyIcon = copyButton.querySelector('.copy-icon');
        if (copiedIcon) {
          copiedIcon.style.display = 'flex';
          copyIcon.style.display = 'none';
          setTimeout(() => {
            copiedIcon.style.display = 'none';
            copyIcon.style.display = 'flex';
          }, 2000);
        }
        if (announcer) {
          announcer.textContent = 'Code copied!';
          setTimeout(() => {
            announcer.textContent = '';
          }, 1500);
        }
      });
    }
  });

  // Add To Cart Button: GA4 'add_to_cart' event
  // Update quantity data attribute
  if (document.querySelector(ns_main_product.QuantityInput)) {
    document
      .querySelector(ns_main_product.QuantityInput)
      .addEventListener('change', ns_main_product.UpdateQuantityDataAttr);
  }

  // GA4 'view_item' event
  // Execute on page load
  const observer = new MutationObserver(() => {
    if (document.querySelector(ns_main_product.AddToCartButton)) {
      WatchGA4Obj(
        MAIN_PRODUCT_VIEW_ITEM_GA4_OBJ,
        ns_main_product.CreateGA4Object,
        1500,
      );
      observer.disconnect();
    }
  });
  observer.observe(document.body, {childList: true, subtree: true});
});
